import { useFetchCallType } from '@rahtab/auth/lib/token-based-auth';
import { useAlert } from '@rahtab/ui';

export default function useSetMaxOrderAmount({ orderId, amount }: { orderId: string; amount: string }) {
  const alert = useAlert();
  const [setMaxOrderAmount, { loading }] = useFetchCallType<{
    result: boolean;
    error?: string;
    message?: string;
  }>('SetReqMaxAmount', {
    skip: true,
    params: `RequestCode=${orderId}&ReqMaxAmount=${amount}`,
    onCompleted(data) {
      const title = data?.result ? 'عملیات با موفقیت انجام شد' : 'خطا در انجام عملیات';
      const message = data.error || data.message;
      alert({ title, message, severity: data?.result ? 'success' : 'error' });
    },
  });
  return [setMaxOrderAmount, { loading }] as const;
}
